// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__qoggp","boxTitle":"Qualiphy_boxTitle__VKA5n","box":"Qualiphy_box__bQb0r","toggleWrap":"Qualiphy_toggleWrap__17WMK"};